import { render, staticRenderFns } from "./originalRecordFile.vue?vue&type=template&id=05302f6d&scoped=true&"
import script from "./originalRecordFile.vue?vue&type=script&lang=js&"
export * from "./originalRecordFile.vue?vue&type=script&lang=js&"
import style0 from "./originalRecordFile.vue?vue&type=style&index=0&id=05302f6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05302f6d",
  null
  
)

export default component.exports